import {observer_mgl, RunInAction} from "mobx-graphlink";
import React from "react";
import {Button, CheckBox, Column, DropDown, DropDownContent, DropDownTrigger, Row, TextInput} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {GetMapObjects} from "../../../Server/DB/mapObjects.js";
import {DMap} from "../../../Server/DB/maps/@Map.js";
import {ObjectEntryUI} from "./OutlinerUI/ObjectEntryUI.js";
import {MapState} from "../../../Store/main/maps/@MapState.js";
import {OrderKey} from "../../../Utils/General/OrderKey.js";
import {RunInAction_Set, TextPlus} from "web-vcore";
import {zIndexes} from "../../../Utils/UI/ZIndexes.js";
import {MapObject} from "../../../Server/DB/mapObjects/@MapObject.js";

export function ObjectsOrderedForOutlinerUI(objects: MapObject[]) {
	return objects
		.OrderBy(a=>a.createdAt)
		.OrderBy(a=>a.position.x)
		.OrderByDescending(a=>a.position.y)
		.OrderBy(a=>a.orderKey ?? OrderKey.mid().key);
}

export let OutlinerScrollView_current: ScrollView|n = null;
export function OutlinerScrollView_Current() { return OutlinerScrollView_current; }

export const OutlinerUI = observer_mgl((props: {map: DMap, mapState: MapState})=>{
	const {map, mapState} = props;
	const objects = GetMapObjects(map.id);
	const objectsByID = objects.ToMap(a=>a.id, a=>a);
	const rootObjects = ObjectsOrderedForOutlinerUI(objects.filter(a=>a.parent == null || objectsByID.get(a.parent) == null));
	return (
		<Column style={{flex: 50}}>
			<Row style={{height: 25}}>
				<TextPlus info={`
					Filter token types: (with description and/or example)
					* "age<1d": Objects created within the last day
					* "has:path": Objects with at least one path (includes disabled ones)
					* "has:mesh": Objects with at least one mesh (includes disabled ones)
					* "is:isoline": Objects currently affecting terrain elevations. (ie. rasterized by terrain solver)
					* "for:terrain": Objects that *can* affect the terrain. (includes disabled elements, terrain regions, etc.)
					* "for:scenery": Objects that *can* place procedural scenery. (includes disabled scenery paths)
					* Add "#" before a token to ignore/disable it. (eg. "coast #is:isoline" is equivalent to "coast")
					* The rest: Interpreted as "words"; each must be found (case-insensitively) in either...
					...the object's name or display-text (eg. label text-override, or derived from associated dream-scene)
				`.AsMultiline(0)}>Filter:</TextPlus>
				<TextInput ml={5} instant style={{flex: 1}} value={mapState.outliner.filter_text} onChange={val=>RunInAction_Set(()=>mapState.outliner.filter_text = val)}/>
				<DropDown>
					<DropDownTrigger><Button ml={5} mdIcon="cog" size={25}/></DropDownTrigger>
					<DropDownContent style={{zIndex: zIndexes.dropDown, right: 0, width: 220, background: "rgba(0,0,0,.9)", borderRadius: 5}}>
						<CheckBox text="Match pass-through" value={mapState.outliner.filter_matchPassThrough} onChange={val=>RunInAction_Set(()=>mapState.outliner.filter_matchPassThrough = val)}/>
						<CheckBox mt={5} text="Only visible+selected" value={mapState.outliner.filter_onlyVisibleOrSelected} onChange={val=>RunInAction_Set(()=>mapState.outliner.filter_onlyVisibleOrSelected = val)}/>
					</DropDownContent>
				</DropDown>
			</Row>
			<ScrollView ref={c=>{
				OutlinerScrollView_current = c;
				return ()=>void(OutlinerScrollView_current = null);
			}} style={{height: "calc(100% - 25px)"}} onClick={e=>{
				RunInAction("OutlinerUI.onClick", ()=>{
					mapState.activeObject = null;
					mapState.selectedObjects = [];
				});
			}}>
				{rootObjects.map(object=>{
					return <ObjectEntryUI {...{map}} key={object.id} obj={object} ancestors={[]}/>;
				})}
			</ScrollView>
		</Column>
	);
});